import React from 'react';

const BaseLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

export default BaseLayout;
